import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromoCodeRouteModule } from './promocode-route/promocode-route.module';
import {PromotionCodeService} from './../master/services/promotion-code.service';
import {PromotionCodeLogService} from './../report/services/promotion-code-log.service';

@NgModule({
  imports: [
    CommonModule,
    PromoCodeRouteModule
  ],
  declarations: [],
  providers: [PromotionCodeService, PromotionCodeLogService]
})
export class PromoCodeModule { }



// WEBPACK FOOTER //
// ./src/app/section/promocode/promocode.module.ts